import * as ServerComms from './ServerComms';

// ai:{},
export function baseCode(){
  return {sc:{}, oc:{}, ov:{}, os:{}, pu:{}, cn:{}, as:{}, st:{}, cp:{}, mu:{}, 
    s:{backgroundColor:{"t":"raw","v":"rgb(255,255,255)"}},"_g":{"_programName":"","ss":"1","curr":{"o":0,"p":0,"O":{}}},
    fe:{'1':{n:"1", ord:0, s:{}, pos:{xP:0, yP:0}, "nv":{"on":0},"_s":{"1":{"_na":"1","al":{}, i:{}, k:{}, ord:0, h:{"t":"vh","v":100}, hl:{t:"int","v":0}, minHeight: {t:'em', v:40}, s:{}}}}}
  };
}

export function actualOptions(itemCategories, itemType){
  if (itemType === 'dapp'){   
    return [ {n:'Mint / Stake / Transfer NFTs', i:3, a:'mdi:alpha-n-circle-outline'}, 
            {n:'Mint / Stake / Transfer ERC20 Tokens', i:4, a:'icomoon-free:coin-dollar'}, 
              {n:'Subscriptions', i:6, a:'eos-icons:activate-subscriptions-outlined'}, 
              {n:'Lottery / Jackpot', i:7, a:'game-icons:card-random'}, 
              {n:'Coming Soon / Wait Page', i:2, a:'guidance:waiting-room'}];
  }else{
    return itemCategories.filter((aCat, index)=>{
      return aCat.v[1].v === itemType;
    }).map((aCat, index)=>{
      return {n:aCat.v[2].v, i:aCat.v[0].v, a:aCat.v[3].v};
    })
  }
}


export function refreshTemplatesWithCategories(setTemplates, categoryID){
    function postGetTemplates(response){
      if (response.t === 'list'){
        var t = response.v.map((aT, index)=>{
          return {i:aT.v[0].v, c:JSON.parse(aT.v[1].v)};
        })
        setTemplates(t);
      }
    }
    ServerComms.fetchSomething({u:'getPageTemplates', categoryID}, postGetTemplates);
}

// isContractOfType(contractInfo, contractType, currentList, loc)

export function filteredTemplates(templates, filterBit){
    return templates.filter((aTemplate, index)=>{

        if (filterBit === 'noFilter'){
        }else{
          for (var k = 0; k < aTemplate.t.length; k++){
            var hF = false;
            if (filterBit === aTemplate.t[k]){
              hF = true;
              break;
            }
          }
          if (!hF){
            return false;
          }
        }

        return true;


    }); 
}
